import { ProductCategory } from 'app/shared/models/product-category.model';
import { isLocalDevelopment } from 'app/shared/utilities/helper-functions';

class LocationService {
  public navigateToUrl(url: string): void {
    window.location.href = url;
  }

  public navigateToEligibility(
    productCategory: ProductCategory,
    cidi?: string,
    eligibilityPath?: string,
    cleanQueryParams?: boolean,
    pageName?: string
  ): void {
    let appConfig = '';
    if (productCategory === 'nbn') {
      appConfig = 'nbn';
    } else if (productCategory === 'mobile plan') {
      appConfig = 'mobile plan';
    } else {
      return;
    }

    if (eligibilityPath) appConfig = `${appConfig}-${eligibilityPath}`;

    let urlQuery =
      window.location.search === '' || cleanQueryParams ? `?app-config=${appConfig}` : `${window.location.search}&app-config=${appConfig}`;
    urlQuery = cidi ? urlQuery.concat(`&cidi=${cidi}`) : urlQuery;

    window.location.href = `${window.location.origin}/apps/confirm/${urlQuery}#/${pageName ? pageName : ''}`;
  }

  public navigateToProductBundle(): void {
    const url = `${isLocalDevelopment() ? 'http://localhost:4200/apps/comparison' : ''}/residential/plan-builder`;
    this.navigateToUrl(url);
  }

  public navigateToProductBundleLanding(): void {
    const url = `${
      isLocalDevelopment() ? `${window.location.origin}/apps/comparison` : window.location.origin
    }/residential/plan-builder-landing`;
    this.navigateToUrl(url);
  }

  public navigateToMobileMoving(): void {
    const url = '/residential/mobile-plans/moving';
    this.navigateToUrl(url);
  }

  public navigateToNbnMoving(): void {
    const url = '/residential/nbn-plans/moving';
    this.navigateToUrl(url);
  }

  public navigateToCart(): void {
    const url = '/cart?cidi=A11097';
    this.navigateToUrl(url);
  }

  public navigateToMoversEligibility(): void {
    const url = '/apps/confirm/?app-config=movers#/movers/address';
    this.navigateToUrl(url);
  }
}

export const locationService = new LocationService();
